import { circleIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Generic = createIcon({
  displayName: 'Generic',
  paths: [
    'M128 512c0-212.096 171.904-384 384-384s384 171.904 384 384c0 212.096-171.904 384-384 384s-384-171.904-384-384zM832 512c0-176.469-143.531-320-320-320s-320 143.531-320 320c0 176.469 143.531 320 320 320s320-143.531 320-320zM298.667 512c0-117.803 95.531-213.333 213.333-213.333s213.333 95.531 213.333 213.333c0 117.803-95.531 213.333-213.333 213.333s-213.333-95.531-213.333-213.333zM640 512c0-70.571-57.429-128-128-128s-128 57.429-128 128c0 70.571 57.429 128 128 128s128-57.429 128-128z'
  ],
  canvasPaths: canvasIconPaths(circleIcon)
})
